let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("knzjr")).then(() => parcelRequire('4W57j'));